export default class Passo5 {
  constructor(id, lista = []) {
    this.id = id;
    this.lista = lista;
  }
}
